import GeneratedUserServiceApi from "./generated/GeneratedUserServiceApi"

class UserServiceApi extends GeneratedUserServiceApi {

}

export const userServiceApi = new UserServiceApi()
